export function parseRelatedColourwaysMetafield(product) {
    var _a;
    const mf = (_a = product.metafields) === null || _a === void 0 ? void 0 : _a.find((m) => m.namespace === 'custom' && m.key === 'related_colourways' && m.value);
    if (!(mf === null || mf === void 0 ? void 0 : mf.value))
        return [];
    try {
        const parsed = JSON.parse(mf.value);
        return Array.isArray(parsed) ? parsed : [];
    }
    catch (_b) {
        return [];
    }
}
/** Storefront `Product` GID, or null if the value cannot be interpreted. */
export function normalizeShopifyProductGid(raw) {
    if (raw == null || raw === '')
        return null;
    const s = String(raw).trim();
    if (!s)
        return null;
    if (s.startsWith('gid://shopify/Product/'))
        return s;
    if (/^\d+$/.test(s))
        return `gid://shopify/Product/${s}`;
    return null;
}
export function relatedColourwayStorefrontIds(product) {
    const seen = new Set();
    for (const s of parseRelatedColourwaysMetafield(product)) {
        const gid = normalizeShopifyProductGid(s.id);
        if (gid)
            seen.add(gid);
    }
    return Array.from(seen);
}
/**
 * Resolve a colour name to its theme-defined CSS custom property reference.
 *
 *   getColourVariable('Black')      → 'var(--swatch-black)'
 *   getColourVariable('Dark Brown') → 'var(--swatch-dark-brown)'
 *
 * The Aquila theme defines `--swatch-<kebab-name>` custom properties on
 * `<html>` from the merchant's `settings.swatches_config` (see
 * `snippets/color-swatch-css-vars.liquid` in `aquila-shopify`). Use this
 * helper anywhere a Preact card renders a colour dot so the swatch styling
 * stays consistent across the PLP tile (`ProductCard`) and the mini-cart
 * tile (`MiniCartProductCard`).
 *
 * Pair with the metafield-based hex precedence used in `bgHex` /
 * `variantSwatchHex`: try an explicit `styleColourHex` / `hex_colour` value
 * first, then fall back to this helper for the named colour.
 */
export function getColourVariable(colourName) {
    const colourVariable = colourName.toLowerCase().replace(' ', '-');
    return `var(--swatch-${colourVariable})`;
}
